module.exports = __webpack_public_path__ + "static/media/1-F.1850322c.webp";